/**
 * @file Person Listview
 * @author tobias.frei@notch-interactive.com
 *
 * @module modules/tabs
 *
 */

const instance = {},

    /**
     *
     * @typedef defaults
     */

    defaults = {
        friendTrigger: 'btn-addfriend',
        classes: {
            addFriend: 'add-friends'
        },
        hooks: {
            mainModule: '[data-m-personlistview]'
        },
        boundAttr: 'data-personlist-bound'
    };

let settings,
    listviews;

    /* private methods */
const bindEvents = () => {
        listviews.forEach((listview) => {

            // Set the bound Attribute, so that this module doesn't initiate the factory multiple times over the same elements
            listview.setAttribute(settings.boundAttr, '');

            let addFriendButton = listview.querySelector('.' + settings.friendTrigger);

            if (addFriendButton) {
                addFriendButton.mainModule = listview;
                addFriendButton.addEventListener('click', friendTrigger, false);
            }
        });
    },
    unbindEvents = () => {
        listviews.forEach((listview) => {

            // Set the bound Attribute, so that this module doesn't initiate the factory multiple times over the same elements
            listview.removeAttribute(settings.boundAttr);
            listview.querySelector('.' + settings.friendTrigger).removeEventListener('click', friendTrigger, false);
        });
    },
    friendTrigger = (e) => {
        let target = e.target;
        if(!target.classList.contains('btn-addfriend')) {
            target = target.closest('.' + settings.friendTrigger);
        }
        target.mainModule.classList.add(settings.classes.addFriend);

        // resize tab
        window.requestAnimationFrame(function(){
            window.resizeTabs();
        });
    };

/**
 * Initialize module
 *
 * @param {object} options - Override default settings with options object.
 * @return {object} Instance of created module.
 */

instance.init = (options) => {
    settings = Object.assign({}, defaults, options);

    listviews = [...document.querySelectorAll(settings.hooks.mainModule + ':not([' + settings.boundAttr + '])')];

    // exit if no modules
    if (listviews.length < 1) {
        return;
    }

    bindEvents();

    return instance;
};

/**
 * Destroy this module.
 */

instance.destroy = () => {
    unbindEvents();
};

/**
 * Resize open accordions.
 */

instance.resize = () => {
    resize();
};

export default instance;
